import React, { useEffect, useState } from "react";
import "./Home.css";
import React1 from "../images/React1.png";
import Node1 from "../images/NodeJS.png";
import MongoDB1 from "../images/Mongo DB.png";
import Lottie from "lottie-react";
import { useLocation, useNavigate } from "react-router-dom";
import techAnim from "../assests/TechAnimation.json";
import uxAnim from "../assests/UX&UIanimationgrey.json";
import customAnim from "../assests/CustomSDanimation.json";
import mobAnimation from "../assests/MobileAppAnimation.json";
import HeroAnimatedBackground from "./sections/HeroAnimatedBackground";
import ProductsSection from "./sections/ProductsSection";
import TechStackSection from "./sections/TechStackSection";
import IndustriesSection from "./sections/IndustriesSection";
import WhyQuinterraSection from "./sections/WhyQuinterraSection";
import TeamSection from "./sections/TeamSection";
import TractionSection from "./sections/TractionSection";
import CompanyInfoSection from "./sections/CompanyInfoSection";
import "./sections/SaasSections.css";
import favicon from "../images/favicon.png";
export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToServicesSection = () => {
    const section = document.getElementById("services-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo === "services") {
      scrollToServicesSection();
    }
  }, [location]);

  const handleMobileServiceNavigation = (route) => {
    if (window.innerWidth <= 768) {
      navigate(route);
    }
  };

  const handleContactNavigation = () => {
    navigate("/about", { state: { scrollTo: "contact" } });
  };

  const handleProductsNavigation = () => {
    const section = document.getElementById("products-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/products");
    }
  };

  return (
    <div className="HomeContainer">
      <div className="HeroContainerWrapper">  
      <div className="HeroContainer">
        <div className="HomeRight">
          <div className="bannerRightWrapper">
          <div className="bannerRight">
          <HeroAnimatedBackground />
            <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
            <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>

            <div className="contentRight hero-copy-block">
              {/* <h1 className="hero-company-name">Quinterra Software Solutions Pvt. Ltd.</h1> */}
              <h1 className="hero-subheadline">
                We build AI-powered SaaS products for HR, Education,CRM, Staffing, and Enterprise Operations.
              </h1>
              <p className="hero-description">
                Our cloud-native platforms help businesses automate workflows, reduce manual effort, and scale efficiently using AI, analytics, and automation.
              </p>
            </div>
          </div>
          <div className="cta_button">
            <button onClick={handleContactNavigation}>Get in Touch</button>
          </div>

          {/* <div className="cta_button cta_button--dual">
            <button onClick={handleProductsNavigation}>Explore Products</button>
            <button className="cta-secondary" onClick={handleContactNavigation}>Contact Us</button>
          </div> */}
          <div className="curve1"></div>
        </div>  
        </div>
        <div className="HomeLeft">
          <div className="bannerLeftWrapper">
          <div className="bannerLeft1">
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}   ></div>
            <div className="content_top_left">
         
            <div className="content_top">
              <h1>Explore Our <br></br>Services</h1>
              <p>Our expertise 
                spans across various industries and platforms, ensuring we deliver products that 
                are fit for purpose and built to last.</p>
            </div>
            <div className="hover_in">
            <h1>Explore Our<br></br>Services</h1>
              <div className="hover_in_content">
              <img src={React1} className="hover_in_image" alt="hover_in" />
              <img src={Node1} className="hover_in_image" alt="hover_in" />
              <img src={MongoDB1} className="hover_in_image" alt="hover_in" />
              </div>
              <button
                className="view_more_button"
                onClick={scrollToServicesSection}
              >
                View More
              </button>
            </div>
          </div>
          </div>
          <div className="bannerLeft2">
 
  <div className="content_top_left">

    <div className="content_top">
      <h1>View Our <br />Products</h1>
      <p>
        Discover our AI-driven product ecosystem, featuring enterprise chatbots,
        smart HR and contract tools, and digital platforms for education, retail, and media
      </p>
    </div>
    <div className="hover_in">
      <h1>View Our <br />Products</h1>
      <div className="hover_in_content">
        <img src={favicon} className="hover_in_image" alt="hover_in" />
        <img src={favicon} className="hover_in_image" alt="hover_in" />
        <img src={favicon} className="hover_in_image" alt="hover_in" />
      </div>
      <button className="view_more_button" onClick={handleProductsNavigation}>
        View More Products
      </button>
    </div>
  </div>
</div>
          </div>
        </div>
        
      </div>
      </div>
      <div className="bottomSection">
  <div className="bottomLeft">
    <div className="card-container">
      <div className="card-container-1">
        <h1>
          AI-POWERED <br /> SAAS PLATFORMS
        </h1>
        <p>
          Cloud-native products for HR, education, CRM, and enterprise operations — built with AI at the core.
        </p>
      </div>
    </div>
  </div>
  <div className="bottomRight">
    <div className="card-container-a">
      <div className="card-container-2">
        <h1>
          SCALE WITH <br /> AUTOMATION
        </h1>
        <p>
          Reduce manual effort and grow efficiently with analytics, AI agents, and intelligent workflow automation.
        </p>
      </div>
    </div>
    </div>
</div>

<ProductsSection />
<TechStackSection />
<IndustriesSection />
<WhyQuinterraSection />
{/* <TeamSection /> */}
<TractionSection />
<CompanyInfoSection />
      
{/* <div className="servicesSection" id="services-section">
  <h1 className="servicesHeading">SERVICES</h1>

  <div className="servicesGrid">
    <div
      className="serviceCard"
      onClick={() => handleMobileServiceNavigation("/mobile-app")}
    >
      <div className="topContent">
        <p>ANDROID APPS</p>
        <p>IOS APPS</p>
      </div>

      <div className="centerContent mobile-app orderIconFirst">
           <Lottie animationData={mobAnimation} className="serviceAnim" />
        <h2>MOBILE APP<br/>DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>HYBRID APPS</p>
        <p>APP SUPPORT & MAINTENANCE</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/custom")}
    >
      <div className="topContent">
        <p>DESKTOP APPS</p>
        <p>DATA PIPELINES</p>
      </div>

      <div className="centerContent custom orderTextFirst">
        <Lottie animationData={customAnim} className="serviceAnim" />
        <h2>CUSTOM SOFTWARE<br />DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>IOT APPS</p>
        <p>SOFTWARE SUPPORT <br/>SERVICES</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/website")}
    >
      <div className="topContent">
        <p>ECOMMERCE</p>
        <p>STATIC SITS</p>
      </div>

      <div className="centerContent website orderIconFirst">
        <Lottie animationData={techAnim} className="serviceAnim" />
        <h2>WEBSITE DESIGN<br />& DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>CMS & DYNAMIC</p>
        <p>DIGITAL MARKETING</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/ux-services")}
    >
      <div className="topContent">
        <p>PROTOTYPING</p>
        <p>BRANDING</p>
      </div>

      <div className="centerContent ux orderTextFirst">
        <Lottie animationData={uxAnim} className="serviceAnim" />
        <h2>UX & UI DESIGN<br />SERVICES</h2>
      </div>

      <div className="bottomContent">
        <p>VISUAL DESIGN</p>
        <p>INFORMATION ARCHITECTURE</p>
      </div>
    </div>

  </div>
</div> */}
<div className="servicesSection" id="services-section">
  <h1 className="servicesHeading">SERVICES</h1>

  <div className="servicesGrid">
    <div
      className="serviceCard"
      onClick={() => handleMobileServiceNavigation("/mobile-app")}
    >
      <div className="topContent">
        <p>ANDROID APPS</p>
        <p>IOS APPS</p>
      </div>

      <div className="centerContent mobile-app orderIconFirst">
           <Lottie animationData={mobAnimation} className="serviceAnim" />
        <h2>MOBILE APP<br/>DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>HYBRID APPS</p>
        <p>APP SUPPORT & MAINTENANCE</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/custom")}
    >
      <div className="topContent">
        <p>DESKTOP APPS</p>
        <p>DATA PIPELINES</p>
      </div>

      <div className="centerContent custom orderTextFirst">
        <Lottie animationData={customAnim} className="serviceAnim" />
        <h2>CUSTOM SOFTWARE<br />DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>IOT APPS</p>
        <p>SOFTWARE SUPPORT <br/>SERVICES</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/website")}
    >
      <div className="topContent">
        <p>ECOMMERCE</p>
        <p>STATIC SITS</p>
      </div>

      <div className="centerContent website orderIconFirst">
        <Lottie animationData={techAnim} className="serviceAnim" />
        <h2>WEBSITE DESIGN<br />& DEVELOPMENT</h2>
      </div>

      <div className="bottomContent">
        <p>CMS & DYNAMIC</p>
        <p>DIGITAL MARKETING</p>
      </div>
    </div>
    <div
      className="serviceCard advancedCard"
      onClick={() => handleMobileServiceNavigation("/ux-services")}
    >
      <div className="topContent">
        <p>PROTOTYPING</p>
        <p>BRANDING</p>
      </div>

      <div className="centerContent ux orderTextFirst">
        <Lottie animationData={uxAnim} className="serviceAnim" />
        <h2>UX & UI DESIGN<br />SERVICES</h2>
      </div>

      <div className="bottomContent">
        <p>VISUAL DESIGN</p>
        <p>INFORMATION ARCHITECTURE</p>
      </div>
    </div>

  </div>
</div>

<div className="offerSection">
  <h1 className="offerTitle">WE OFFER</h1>

  <div className="offerContent">

    <div className="offerContentWrapper">
      <div className="offerText">
      <span className="filled">FLEXIBLE</span>
      <span className="outline">FLEXIBLE</span>
      <span className="filled">FLEXIBLE</span>
      <span className="outline">FLEXIBLE</span>
       </div>
    <div className="offerOverlay">
  <h2>FLEXIBLE</h2>
  <p>
    Software flexibility is one of the properties that indicate if the software is easy to change.
    Flexible software can easily adapt to user requirement and/or environment changes.
  </p>
  </div>
    </div>

    <div className="offerContentWrapper">

  <div className="offerText">
    <span className="outline">CREATIVE</span>
    <span className="filled">CREATIVE</span>
    <span className="outline">CREATIVE</span>
    <span className="filled">CREATIVE</span>
  </div>

  <div className="offerOverlay">
    <h2>CREATIVE</h2>
    <p>
      The main goal of a creative team is to design and execute campaigns that encourage a target audience to buy a company’s products or services. The team is also responsible for creating a consistent brand image for the company through its look, voice, and messaging.
    </p>
  </div>

</div>

    <div className="offerContentWrapper">

  <div className="offerText">
    <span className="filled">DESIGN</span>
    <span className="outline">DESIGN</span>
    <span className="filled">DESIGN</span>
    <span className="outline">DESIGN</span>
     <span className="filled">DESIGN</span>
  </div>

  <div className="offerOverlay">
    <h2>DESIGN</h2>
    <p>
      Software design is a process to transform user requirements into some suitable form, which helps the programmer in software coding and implementation.
    </p>
  </div>

</div>
   <div className="offerContentWrapper">

  <div className="offerText">
    <span className="outline">INNOVATIVE</span>
    <span className="filled">INNOVATIVE</span>
    <span className="outline">INNOVATIVE</span>
    <span className="filled">INNOVATIVE</span>
  </div>

  <div className="offerOverlay">
    <h2>INNOVATIVE</h2>
    <p class='a'>
      Innovation software goes beyond simply working to generate new ideas and can actually be used to identify new markets and develop disruptive business models that have yet to even be considered.
    </p>
  </div>

</div>
  </div>
</div>
<div className="offerMobile">

  <h1 className="offerTitle1">WE OFFER</h1>

  <div className="offerItem">
    <h2>FLEXIBLE</h2>
    <p>
      Software flexibility is one of the properties that indicate if the software is easy to change. Flexible software can easily adapt to user requirement and/or environment changes during the software development period or after the software is deployed.
    </p>
  </div>

  <div className="offerItem">
    <h2>CREATIVE</h2>
    <p>
      The main goal of a creative team is to design and execute campaigns that encourage a target audience to buy a company’s products or services. The team is also responsible for creating a consistent brand image for the company through its look, voice, and messaging
    </p>
  </div>

  <div className="offerItem">
    <h2>DESIGN</h2>
    <p>
      Software design is a process to transform user requirements into some suitable form, which helps the programmer in software coding and implementation.
    </p>
  </div>

  <div className="offerItem">
    <h2>INNOVATIVE</h2>
    <p>
      Innovation software goes beyond simply working to generate new ideas and can actually be used to identify new markets and develop disruptive business models that have yet to even be considered. Innovation software becomes an invaluable tool that has the power to completely reinvent existing markets.
    </p>
  </div>

</div>
    </div>
  );
}
